import { render, staticRenderFns } from "./cjScore.vue?vue&type=template&id=380ae080&"
import script from "./cjScore.vue?vue&type=script&lang=ts&"
export * from "./cjScore.vue?vue&type=script&lang=ts&"
import style0 from "./cjScore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports